import React, {useState} from 'react';
import {Select} from '@mantine/core';
import {useField} from "formik";

function MantineSelectField(props) {
    const [field, meta, helpers] = useField(props.name);
    const [value, setValue] = useState(field.value);
    const {setValue: setFieldValue, setTouched} = helpers;

    return (
        <Select
            {...props}
            value={value}
            maxDropdownHeight={200}
            nothingFound="Sin resultados"
            onChange={(v) => {
                setValue(v)
                setFieldValue(v)
                setTouched(props.name, false)
                if (props.onChangeAction) {
                    props.onChangeAction(v)
                }
            }}
            error={meta.error && meta.touched && <div>{meta.error}</div>}
        />
    );
}

export default MantineSelectField;